import React from "react";
import { Input } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const TextField = ({ field, control, disabled, error, required, compact }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required} compact={compact}>
        <Input {...input} value={input.value ?? ""} placeholder={field.placeholder} isDisabled={disabled} size="sm" />
      </FieldFrame>
    )}
  />
);

export default TextField;
